import { useCallback, useState } from 'react';
import i18next from '../../i18n';

export default function PublicSupportBridge() {
  const [isOpening, setIsOpening] = useState(false);

  const openSupport = useCallback(async () => {
    if (isOpening) return;
    setIsOpening(true);

    try {
      const { Crisp } = await import('crisp-sdk-web');
      Crisp.configure('4036929b-9e7e-428c-8f84-51f491884aca', {
        autoload: true,
        locale: i18next.language,
      });
      Crisp.chat.show();
      Crisp.chat.open();
    } finally {
      setIsOpening(false);
    }
  }, [isOpening]);

  return (
    <button
      id="support-button"
      type="button"
      className="hidden"
      onClick={openSupport}
      aria-label="Open chat support"
    />
  );
}
